import withTransactionsList from 'modules/Wallet/withTransactionsList';
import { WalletPage as WalletPageComponent } from './WalletPage';

export const WalletPage = withTransactionsList(WalletPageComponent);
